import React from 'react';
import { DeviceImportRequest } from 'types';


type Props = {
    importRequests: DeviceImportRequest[]
}

const TableValidLicensePlates = (props: Props) => (
    <table className="tbl-import-requests-validation tbl-valid">
        <tbody>
            {props.importRequests.map((request, i) => (
                <tr key={i}>
                    <td>{request.request.licensePlate}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default TableValidLicensePlates;